(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-forms-basin"] && !Shopify.designMode) return;
  try {
    (function () {
    function emailValid(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }
    function phoneValid(v) {
      return /^\+?[0-9][0-9\s().-]{6,19}$/.test(v);
    }
    // Normalize to E.164 so Basin (and downstream Zendesk/Klaviyo) get a clean number.
    function normalizePhone(raw) {
      var digits = (raw || '').replace(/\D/g, '');
      if (digits.length === 10) return '+1' + digits;
      if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
      if (digits.length > 0 && raw.charAt(0) === '+') return '+' + digits;
      return raw;
    }

    function pad2(n) { return (n < 10 ? '0' : '') + n; }

    // Local "today" as YYYY-MM-DD. Computed client-side on purpose: the storefront
    // HTML is CDN-cached, so a Liquid-rendered date could be stale and wrongly block
    // valid recent purchase dates. The visitor's browser clock is always current.
    function todayISO() {
      var d = new Date();
      return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
    }

    // Validate a native date-input value. The browser hands back YYYY-MM-DD, but the
    // year segment accepts 5+ digits -- that is how "20026-06-16" reached the warranty
    // automation and crashed it. Returns an error message, or '' when acceptable.
    function dateError(input, value) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
      if (!m) return 'Please enter a valid date using the date picker.';
      var y = +m[1], mo = +m[2], da = +m[3];
      var d = new Date(y, mo - 1, da);
      if (d.getFullYear() !== y || d.getMonth() !== mo - 1 || d.getDate() !== da) {
        return 'Please enter a valid date using the date picker.';
      }
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      if (d.getTime() > today.getTime()) return 'The date of purchase cannot be in the future.';
      var minAttr = input.getAttribute('min');
      var mm = minAttr ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(minAttr) : null;
      if (mm) {
        var minD = new Date(+mm[1], +mm[2] - 1, +mm[3]);
        if (d.getTime() < minD.getTime()) return 'Please enter a date of purchase from ' + (+mm[1]) + ' or later.';
      }
      return '';
    }

    function fieldErrorEl(input) {
      if (!input) return null;
      var explicit = input.getAttribute('data-error-id');
      if (explicit) return document.getElementById(explicit);
      if (input.id) return document.getElementById(input.id + '-error');
      // Radio groups share one error by name.
      if (input.name) return document.getElementById('basin-error-' + input.name);
      return null;
    }

    function setDescribedBy(input, errorEl, on) {
      if (!input) return;
      if (on && errorEl && errorEl.id) {
        input.setAttribute('aria-describedby', errorEl.id);
      } else {
        // Drop describedby when valid so empty/hidden error text is not announced.
        var current = input.getAttribute('aria-describedby') || '';
        if (errorEl && errorEl.id && current === errorEl.id) {
          input.removeAttribute('aria-describedby');
        } else if (!errorEl) {
          // leave other describedby sources alone
        }
      }
    }

    // Set both the inline error text and the data-error-msg (used by the error
    // summary) so a field can carry a context-specific message, e.g. future date.
    function setErrorMsg(input, msg) {
      input.setAttribute('data-error-msg', msg);
      var el = fieldErrorEl(input);
      if (el) el.textContent = msg;
    }

    function validateInput(input) {
      // Skip fields hidden by conditional logic (and disabled radios).
      if (input.disabled || (input.closest && input.closest('.is-hidden'))) return true;
      var valid = true;
      if (input.type === 'radio') {
        if (input.hasAttribute('required')) {
          var owner = input.form || document;
          var group = owner.querySelectorAll('[name="' + input.name + '"]');
          var anyChecked = false;
          for (var ri = 0; ri < group.length; ri++) {
            if (group[ri].checked) { anyChecked = true; break; }
          }
          // Only validate once per radio group (first required radio).
          if (input !== group[0]) return true;
          if (!anyChecked) valid = false;
        }
      } else if (input.type === 'checkbox') {
        if (input.hasAttribute('required') && !input.checked) valid = false;
      } else {
        var value = (input.value || '').trim();
        if (input.type === 'date') {
          // All date handling lives here (including required-empty) so the message is
          // always recomputed -- a stale "future date" error never lingers after the
          // field is cleared or corrected.
          var dDefault = input.getAttribute('data-error-default') || input.getAttribute('data-error-msg') || '';
          var dMsg = dDefault;
          if (input.hasAttribute('required') && !value) {
            valid = false;
          } else if (value) {
            var de = dateError(input, value);
            if (de) { valid = false; dMsg = de; }
          }
          setErrorMsg(input, dMsg);
        } else if (input.hasAttribute('required') && !value) {
          valid = false;
        } else if (input.type === 'email' && value && !emailValid(value)) {
          valid = false;
        } else if (input.type === 'tel' && value && !phoneValid(value)) {
          valid = false;
        }
      }
      var err = fieldErrorEl(input);
      if (!valid) {
        input.setAttribute('aria-invalid', 'true');
        if (err) {
          err.setAttribute('aria-hidden', 'false');
          setDescribedBy(input, err, true);
          // Mark all radios in the group invalid for consistent SR state.
          if (input.type === 'radio' && input.name) {
            var owner = input.form || document;
            [].slice.call(owner.querySelectorAll('[name="' + input.name + '"]')).forEach(function (r) {
              r.setAttribute('aria-invalid', 'true');
              setDescribedBy(r, err, true);
            });
          }
        }
      } else {
        input.removeAttribute('aria-invalid');
        if (err) err.setAttribute('aria-hidden', 'true');
        setDescribedBy(input, err, false);
        if (input.type === 'radio' && input.name) {
          var ownerOk = input.form || document;
          [].slice.call(ownerOk.querySelectorAll('[name="' + input.name + '"]')).forEach(function (r) {
            r.removeAttribute('aria-invalid');
            setDescribedBy(r, err, false);
          });
        }
      }
      return valid;
    }

    function initForm(form) {
      var submitBtn = form.querySelector('[data-submit]');
      var summary = form.querySelector('[data-error-summary]');
      var summaryList = form.querySelector('[data-error-list]');
      var success = form.querySelector('[data-success]');
      var errorEmailEl = form.querySelector('[data-error-email]');
      var errorEmail = errorEmailEl ? errorEmailEl.textContent.trim() : '';

      // Conditional fields: reveal + require only when their controller matches.
      // Supports radio groups, multi-field wraps, and notice-only wraps (no inputs).
      function controllerValue(name) {
        var nodes = form.querySelectorAll('[name="' + name + '"]');
        if (!nodes.length) return '';
        if (nodes[0].type === 'radio') {
          var checked = form.querySelector('[name="' + name + '"]:checked');
          return checked ? checked.value : '';
        }
        return nodes[0].value;
      }

      function wrapFields(wrap) {
        return [].slice.call(wrap.querySelectorAll('input, select, textarea')).filter(function (el) {
          return el.name && el.name !== '_gotcha' && el.type !== 'hidden' && el.type !== 'radio';
        });
      }

      function isHiddenField(el) {
        return !!(el.closest && el.closest('.is-hidden'));
      }

      var conditionals = [].slice.call(form.querySelectorAll('[data-show-when]'));
      var controllerNames = {};
      conditionals.forEach(function (wrap) {
        var controllerName = wrap.getAttribute('data-show-when');
        if (controllerName) controllerNames[controllerName] = true;
      });

      function syncConditionals() {
        conditionals.forEach(function (wrap) {
          var controllerName = wrap.getAttribute('data-show-when');
          var showValue = wrap.getAttribute('data-show-value');
          var optional = wrap.hasAttribute('data-optional');
          var match = controllerValue(controllerName) === showValue;
          wrap.classList.toggle('is-hidden', !match);
          wrapFields(wrap).forEach(function (field) {
            if (match && !optional && !field.hasAttribute('data-optional')) {
              field.setAttribute('required', '');
              field.setAttribute('aria-required', 'true');
              field.disabled = false;
            } else {
              field.removeAttribute('required');
              field.removeAttribute('aria-required');
              if (!match) {
                field.value = '';
                field.removeAttribute('aria-invalid');
                var err = fieldErrorEl(field);
                if (err) err.setAttribute('aria-hidden', 'true');
              }
            }
          });
          [].slice.call(wrap.querySelectorAll('input[type="radio"]')).forEach(function (radio) {
            radio.disabled = !match;
            if (!match) radio.checked = false;
          });
        });

        // Hide submit when the gate only points people to the other form.
        if (submitBtn) {
          var gateCustomer = controllerValue('existing_customer');
          var gateResearcher = controllerValue('existing_researcher');
          var hideSubmit =
            gateCustomer === "Yes, I'm an existing customer" ||
            gateResearcher === 'No';
          submitBtn.classList.toggle('is-hidden', hideSubmit);
          submitBtn.disabled = hideSubmit;
        }

        // If a gate notice just became visible, make it programmatically focusable
        // so keyboard/SR users hear the redirect instruction without hunting.
        var notice = form.querySelector('.basin-form__notice:not(.is-hidden)');
        if (notice && !notice.hasAttribute('tabindex')) {
          notice.setAttribute('tabindex', '-1');
        }
      }

      Object.keys(controllerNames).forEach(function (name) {
        [].slice.call(form.querySelectorAll('[name="' + name + '"]')).forEach(function (el) {
          el.addEventListener('change', syncConditionals);
        });
      });
      syncConditionals();

      var inputs = [].slice.call(form.querySelectorAll('input, textarea, select')).filter(function (el) {
        return el.name && el.name !== '_gotcha' && el.type !== 'hidden';
      });

      function clearErrors() {
        inputs.forEach(function (input) {
          input.removeAttribute('aria-invalid');
          var err = fieldErrorEl(input);
          if (err) err.setAttribute('aria-hidden', 'true');
          setDescribedBy(input, err, false);
        });
        if (summary) summary.classList.remove('is-visible');
        if (summaryList) summaryList.innerHTML = '';
      }

      inputs.forEach(function (input) {
        var evt = (input.type === 'checkbox' || input.type === 'radio' || input.tagName === 'SELECT') ? 'change' : 'blur';
        input.addEventListener(evt, function () { validateInput(input); });
        input.addEventListener('input', function () {
          if (input.getAttribute('aria-invalid') === 'true') validateInput(input);
        });
      });

      // Date fields: cap the selectable range at today (client-local, so a CDN-cached
      // page can't ship a stale ceiling). Typing stays the native path -- we never
      // auto-open the picker on a field click, because showPicker() moves keyboard focus
      // into the calendar grid and swallows the first keystrokes. Instead the picker is
      // opened from a separate, clearly visible calendar button (below), so a visitor can
      // either type the date or pick it without the two stealing focus from each other.
      var dateInputs = [].slice.call(form.querySelectorAll('input[type="date"]'));
      dateInputs.forEach(function (di) {
        di.setAttribute('data-error-default', di.getAttribute('data-error-msg') || '');
        di.max = todayISO();
        var wrap = di.closest('[data-date-wrap]');
        var toggle = wrap ? wrap.querySelector('[data-date-toggle]') : null;
        if (toggle && typeof di.showPicker === 'function') {
          // Progressive enhancement: reveal our button (and hide the tiny native icon)
          // only when the browser can open the picker on demand. Otherwise the native
          // icon stays as the fallback.
          wrap.classList.add('has-custom-picker');
          toggle.addEventListener('click', function () {
            try { di.showPicker(); } catch (e) { di.focus(); }
          });
        }
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearErrors();

        var invalid = inputs.filter(function (input) { return !validateInput(input); });
        if (invalid.length > 0 && summary && summaryList) {
          invalid.forEach(function (input) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            var target = input;
            // Prefer a focusable control with an id (first radio in a group).
            if (input.type === 'radio' && input.name) {
              var group = form.querySelectorAll('[name="' + input.name + '"]');
              if (group.length) target = group[0];
            }
            var targetId = target.id || input.id;
            a.href = targetId ? ('#' + targetId) : '#';
            a.textContent = input.getAttribute('data-error-msg') || 'This field is required.';
            a.addEventListener('click', function (ev) {
              ev.preventDefault();
              target.focus();
            });
            li.appendChild(a);
            summaryList.appendChild(li);
          });
          summary.classList.add('is-visible');
          requestAnimationFrame(function () {
            var heading = summary.querySelector('p[tabindex]');
            if (heading) {
              heading.focus();
              var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              heading.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
            }
          });
          return;
        }

        // Clean the phone in place so the submitted payload carries E.164.
        var phoneInput = form.querySelector('input[type="tel"]:not(:disabled)');
        if (phoneInput && !phoneInput.closest('.is-hidden')) {
          phoneInput.value = normalizePhone(phoneInput.value);
        }

        // Compose a single message field for Make/Zendesk templates.
        var composeEl = form.querySelector('[data-compose-message]');
        if (composeEl) {
          var mode = composeEl.getAttribute('data-compose-message');
          var lines = [];
          if (mode === 'researcher_info') {
            lines.push('Researcher Info Request');
            lines.push('Existing study customer: ' + controllerValue('existing_customer'));
            lines.push('University Affiliation: ' + ((form.querySelector('[name="university_affiliation"]') || {}).value || ''));
            lines.push('Interest: ' + ((form.querySelector('[name="interest_message"]') || {}).value || ''));
          } else if (mode === 'researcher_support') {
            lines.push('Researcher Support Request');
            lines.push('Existing researcher: ' + controllerValue('existing_researcher'));
            lines.push('University Affiliation: ' + ((form.querySelector('[name="university_affiliation"]') || {}).value || ''));
            lines.push('Subjects: ' + ((form.querySelector('[name="subjects_count"]') || {}).value || ''));
            lines.push('Devices: ' + ((form.querySelector('[name="devices_count"]') || {}).value || ''));
            lines.push('Serial: ' + ((form.querySelector('[name="skyn_serial_number"]') || {}).value || ''));
            lines.push('iOS device: ' + ((form.querySelector('[name="ios_device_version"]') || {}).value || ''));
            lines.push('iOS software: ' + ((form.querySelector('[name="ios_software_version"]') || {}).value || ''));
            lines.push('Issue type: ' + controllerValue('issue_type'));
            lines.push('Issue other: ' + ((form.querySelector('[name="issue_other"]') || {}).value || ''));
            lines.push('Issue details: ' + ((form.querySelector('[name="issue_details"]') || {}).value || ''));
          } else if (mode === 'criminal_justice') {
            lines.push('Criminal Justice Info Request');
            lines.push('Company / Organization: ' + ((form.querySelector('[name="company"]') || {}).value || ''));
            lines.push('Website: ' + ((form.querySelector('[name="website"]') || {}).value || ''));
            lines.push('Job Title: ' + ((form.querySelector('[name="job_title"]') || {}).value || ''));
            lines.push('People to be monitored: ' + controllerValue('people_monitored'));
            lines.push('Planning to use BACtrack Skyn:');
            lines.push((form.querySelector('[name="use_plan"]') || {}).value || '');
          }
          composeEl.value = lines.join('\n');
        }

        try {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sending...';
        }

        var formData = new FormData(form);

        // Abort hung submissions so the button never sticks on 'Sending...'
        // forever; the abort lands in .catch (retry message) and .finally (restore).
        var controller = new AbortController();
        var timeoutId = setTimeout(function () { controller.abort(); }, 20000);

        fetch(form.action, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData,
          signal: controller.signal
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Submission failed');
            var firstEl = form.querySelector('input[name="first_name"]');
            var lastEl = form.querySelector('input[name="last_name"]');
            var emailEl = form.querySelector('input[name="email"]');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'generate_lead',
              form_id: form.id,
              form_name: form.getAttribute('data-form-name') || form.getAttribute('data-form-key') || '',
              user_data: {
                email_address: emailEl ? emailEl.value.trim().toLowerCase() : '',
                phone_number: phoneInput ? phoneInput.value : '',
                address: {
                  first_name: firstEl ? firstEl.value.trim() : '',
                  last_name: lastEl ? lastEl.value.trim() : ''
                }
              }
            });
            form.reset();
            syncConditionals();
            if (success) {
              success.classList.add('is-visible');
              requestAnimationFrame(function () {
                var heading = success.querySelector('p[tabindex]');
                if (heading) {
                  heading.focus();
                  heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              });
            }
          })
          .catch(function () {
            if (summary && summaryList) {
              var contact = errorEmail
                ? ' Please try again or contact us at ' + errorEmail + '.'
                : ' Please try again.';
              summaryList.innerHTML = '<li>Something went wrong.' + contact + '</li>';
              summary.classList.add('is-visible');
              requestAnimationFrame(function () {
                var heading = summary.querySelector('p[tabindex]');
                if (heading) heading.focus();
              });
            }
          })
          .finally(function () {
            clearTimeout(timeoutId);
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.getAttribute('data-default-label') || 'Send Message';
            }
          });
        } catch (syncErr) {
          // fetch() (or FormData) can throw synchronously -- e.g. a CSP connect-src
          // block or a bad action URL -- before the promise chain exists, so the
          // .catch/.finally never run. Restore the form and surface the error instead
          // of leaving the button stuck on 'Sending...'.
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-default-label') || 'Send Message';
          }
          if (summary && summaryList) {
            var contactSync = errorEmail
              ? ' Please try again or contact us at ' + errorEmail + '.'
              : ' Please try again.';
            summaryList.innerHTML = '<li>Something went wrong.' + contactSync + '</li>';
            summary.classList.add('is-visible');
            requestAnimationFrame(function () {
              var heading = summary.querySelector('p[tabindex]');
              if (heading) heading.focus();
            });
          }
        }
      });
    }

    var forms = document.querySelectorAll('form.basin-form');
    for (var i = 0; i < forms.length; i++) {
      initForm(forms[i]);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
